import { useEffect, useState } from 'react';
import { Loader } from 'ui';
import { MeetingStatus, MeetingType } from 'types';
import { useUserContext } from 'src/context/UserProvider';
import { useGetJwtTokenQuery } from 'src/hooks/user.hooks';
import { useGetMeetingScoreCard } from 'src/hooks/meeting.hooks';
import { useQueryClient } from 'react-query';
import ScorecardContainer from '../scorecard/ScorecardContainer';
import PostInterviewComponent from './PostInterviewComponent';
import { useMeetingContext } from 'src/context/MeetingProvider';
import { browserName } from 'react-device-detect';

interface Props {}

const AIQuestionsScreen = ({}: Props) => {
	console.log('inside AIQuestionScreen');
	const { meeting, hasAssessmentEnded, ongoingAssessDetails } = useMeetingContext();
	const { isMentorLoggedIn } = useUserContext();
	const queryClient = useQueryClient();

	const [assessmentToken, setAssessmentToken] = useState<string>(ongoingAssessDetails?.token ?? '');

	const { isLoading, refetch } = useGetJwtTokenQuery(
		assessmentToken,
		data => {
			localStorage.removeItem('retryJWTSign');
		},
		() => {
			const retries = Number(localStorage.getItem('retryJWTSign'));
			if (retries < 3) {
				localStorage.setItem('retryJWTSign', String(retries + 1));
				refetch();
			}
		},
	);

	const { data: meetingScoreCardData, isLoading: scorecardLoading } = useGetMeetingScoreCard(meeting?._id || '');

	useEffect(() => {
		// refetch();
		setAssessmentToken(ongoingAssessDetails?.token ?? '');
	}, [ongoingAssessDetails?.token]);

	useEffect(() => {
		queryClient.refetchQueries(['getMeetingScoreCard']);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasAssessmentEnded]);

	useEffect(() => {
		console.log('-----------------');
		console.log('here:meeting:', meeting);
		console.log('here:ongoingAssessDetails:', ongoingAssessDetails);
		console.log('here:hasAssessmentEnded:', hasAssessmentEnded);
		console.log('here:browserName:', browserName);
		console.log('-----------------');
		if (
			!hasAssessmentEnded &&
			(meeting?.isAIInterview || meeting?.meetingType === MeetingType.Assessment) &&
			ongoingAssessDetails?.interviewUrl &&
			(!meeting?.isAIInterview || browserName === 'Chrome')
		) {
			console.log('here:opening interview url:', ongoingAssessDetails.interviewUrl);
			window.open(ongoingAssessDetails.interviewUrl, '_self');
		}
	}, [hasAssessmentEnded, meeting?.isAIInterview, meeting?.meetingType, ongoingAssessDetails?.interviewUrl]);

	if (isLoading || (!hasAssessmentEnded && !ongoingAssessDetails?.token)) {
		return <Loader />;
	}

	if (browserName !== 'Chrome') {
		return (
			<div className="h-full w-full dark:text-white flex flex-col gap-2 justify-center items-center">
				<p className=" text-2xl font-bold">Browser Not Supported</p>
				<p className=" text-base">For a better experience. open with Google Chrome.</p>
			</div>
		);
	}
	console.log('end of AIQuestionScreen');
	return hasAssessmentEnded ? (
		<div className="relative h-screen w-full dark:bg-[#1f2023] ">
			<div className=" max-h-full overflow-y-scroll">
				{isMentorLoggedIn ? <PostInterviewComponent /> : null}

				<div className="mt-4 mb-6">
					{scorecardLoading ? (
						<Loader />
					) : (
						<ScorecardContainer
							scorecardTitle={meetingScoreCardData?.title ?? ''}
							data={{
								status: meetingScoreCardData?.meetingStatus ?? MeetingStatus.COMPLETED,
								meetingScore: meetingScoreCardData?.meetingScore ?? 0,
								skillScores: meetingScoreCardData?.allMeetingSkillScores ?? [],
								meetingId: meeting?._id || '',
							}}
						/>
					)}
				</div>
			</div>
		</div>
	) : null;
	// (
	// 	<iframe
	// 		title="assessment"
	// 		className="h-full w-full"
	// 		src={
	// 			meeting?.isAIInterview && ongoingAssessDetails?.interviewUrl
	// 				? ongoingAssessDetails.interviewUrl
	// 				: session?.role && ![UserRole.JOBSEEKER, UserRole.EXPERIENCED_JOBSEEKER].includes(session?.role)
	// 				  ? `${ASSESS_PLATFORM_FRONTEND}/test?token=${assessmentToken}&remove_header=1&admin-token=${data?.token}`
	// 				  : `${ASSESS_PLATFORM_FRONTEND}/test?token=${assessmentToken}&remove_header=1`
	// 		}
	// 	></iframe>
	// );
};

export default AIQuestionsScreen;
